import React, { useEffect, useRef } from 'react'
import useMovimentacaoPorPosicaoEstoqueHook, {
  LOAD_MESSAGE,
} from './MovimentacaoPorPosicaoEstoqueHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  Periodo,
} from '../../../../components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Button } from 'primereact/button'

function MovimentacaoPorPosicaoEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoPorPosicaoEstoqueHook()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedInventario: state.selectedInventario })
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.GET_INFORMACOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  let dt = useRef(null)

  const onExport = () => {
    dt.current.exportCSV()
  }

  const header = (
    <Button
      style={{ marginLeft: 20 }}
      type="button"
      icon="pi pi-external-link"
      iconPos="left"
      label="CSV"
      onClick={onExport}
    ></Button>
  )

  return (
    <div>
      <PageHeader>8.11 - Extrato de Movimentação por Posição de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-3">
                <CustomDropdown
                  disabled={!selectedTp}
                  placeholder="Selecione um Estoque"
                  optionLabel={'name'}
                  options={state.estoques}
                  label={'Estoque'}
                  onChange={value => localDispatch.onChange('selectedEstoque', value)}
                  value={state.selectedEstoque}
                />
              </div>
              <div className="p-col-3">
                <CustomDropdown
                  filter={true}
                  placeholder="Selecione uma Posicao"
                  optionLabel={'endereco'}
                  options={state.posicoes}
                  label={'Posição de Estoque'}
                  onChange={value => localDispatch.onChange('selectedPosicao', value)}
                  value={state.selectedPosicao}
                  disabled={!selectedTp}
                />
              </div>
              <div className="p-col-6">
                <Periodo
                  btnEnabled={selectedTp}
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  textPesquisar="Procurar"
                  onPesquisar={(pInicial, pFinal) =>
                    localDispatch.getMovimentacaoPorPosição(
                      selectedTp,
                      state.selectedPosicao,
                      pInicial,
                      pFinal,
                    )
                  }
                />
              </div>
              <div className="p-col-12">
                <div style={{ marginTop: 15 }}>
                  <DataTable
                    ref={dt}
                    header={
                      <CustomDataTableHeader
                        onChange={value => localDispatch.onChange('globalFilter', value)}
                        value={state.globalFilter}
                        children={header}
                      />
                    }
                    rows={10}
                    paginator={true}
                    globalFilter={state.globalFilter}
                    value={state.rows}
                    emptyMessage="Não existem informações para a posição selecionada."
                  >
                    <Column
                      field="data_movimentacao"
                      header="Data da Movimentação"
                      style={tableCellCentered()}
                    />
                    <Column
                      field="operacao_estoque"
                      header="Operação"
                      style={tableCellCentered(120)}
                    />
                    <Column
                      field="operacao_estoque_tipo"
                      header="Tipo de Operação"
                      style={tableCellCentered(70)}
                    />
                    <Column
                      field="movimentacao_tipo"
                      header="Tipo de Movimentação"
                      style={tableCellCentered(70)}
                    />
                    <Column field="usuario" header="Usuário" style={tableCellCentered(120)} />
                    <Column field="product_name" header="Produto" style={tableCellCentered(120)} />
                    <Column
                      field="product_code"
                      header="Prod. Código"
                      style={tableCellCentered(150)}
                    />
                    <Column field="quantidade" header="Quantidade" style={tableCellCentered(100)} />
                  </DataTable>
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoPorPosicaoEstoque))
